<template>
  <div class="ih-page-menu ih-page">
    <form @submit.prevent="submit()">
      <h3 class="ih-margin-bottom-15 text-center">選擇歡唱優惠</h3>
      <div class="ih-theme-radio form-group" v-for="deal in $deals" :key="deal.deal_id">
        <div
          class="ih-theme-button-yellow form-check"
          :class="{'ih-active': deal.deal_id === form_deal_id}"
        >
          <input
            type="radio"
            class="form-check-input"
            name="deal"
            :id="'deal_id' + deal.deal_id"
            :value="deal.deal_id"
            v-model="form_deal_id"
          />
          <i class="fa fa-music" aria-hidden="true"></i>
          <label class="form-check-label" :for="'deal_id' + deal.deal_id">{{ deal.display_name }}</label>
        </div>
      </div>

      <br />

      <div class="alert alert-danger text-center" v-if="formError">請選擇歡唱優惠</div>

      <div class="form-group">
        <div class="ih-row-5 row">
          <div class="col-6">
            <a href="/result?message=付款流程取消<br>請重新操作" class="ih-theme-button-white">取消</a>
          </div>
          <div class="col-6">
            <button type="submit" class="ih-theme-button-yellow">下一步</button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>



<script>
export default {
  components: {},

  mixins: [],

  props: [],
  data() {
    return {
      formError: false,

      form_deal_id: null
    };
  },

  computed: {
    $deals() {
      return this.$store.state.deals;
    }
  },
  watch: {},
  methods: {
    submit() {


      if(this.form_deal_id==0){
        this.$store.commit("set_form_deal_id", this.form_deal_id);

        this.$router.push({
            path: "/serial-no"
        });
      }
      else{
        this.$store.commit("set_form_deal_id", this.form_deal_id);

        this.$router.push({
            path: "/payment"
        });
      }

      // if (!this.form_deal_id) {
      //   this.formError = true;

      //   return;
      // }


    }
  },

  created() {
    const { tk: machine_token, msn: machine_sn } = this.$route.query;
    const data = { machine_sn, machine_token };

    this.$store.commit("set_form_machine_sn", machine_sn);

    $.ajax({
      method: "POST",
      url: `${this.apiBase}/api/v1/machines/options`,
      data: data
    })
      .done(res => {
        // tk、msn 錯誤
        if (res.status !== 0) {
          this.$router.push({
            path: "/result",
            query: { message: res.message }
          });

          return;
        }

        this.$store.commit("set_deals", res.deals);
        this.$store.commit("set_payment_methods", res.payment_methods);
      })
      .fail(err => {
        this.$router.push({
          path: "/result",
          query: { message: err.message }
        });
      })
      .always(res => {});
  },
  mounted() {}
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/pages/Menu";
</style>
